<script>
  import ListCase from "@components/List/Case";

  export default {
    components: {
      ListCase
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    computed: {
      formattedList(list) {
        return this.list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          introimage: item.introimage,
          brands: item.brands,
          to: {
            name: 'brand-case-item',
            params: {
              brandAlias: this.$route.params.brandAlias,
              categoryAlias: item.category_alias,
              caseAlias: item.alias,
            },
          },
          // isdealer: item.extrafields.dealer_only.value === "1"
        }))
      },
    }
  }
</script>
<template>
  <section id="case" class="section">
    <div class="container">
      <BaseSectionTitle
        title="成功案例"
        class="text-center"
      />
      <ListCase
        :list="formattedList"
        type="carouse"
        class="mb-5"
      />
      <div class="text-center position-relative" style="z-index: 0;">
        <BaseButton
          class="isStylePrimary isRadius isCol4"
          :to="{ name: 'brand-case-list' }"

        >
          查看所有成功案例
        </BaseButton>
      </div>
    </div>
  </section>
</template>
